import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Search, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";

// Functioning discovery search over launch-ready venues, markets and upcoming events.
export function SearchBar() {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const nav = useNavigate();
  const timer = useRef();

  const onChange = (e) => {
    const val = e.target.value;
    setQ(val);
    clearTimeout(timer.current);
    if (val.trim().length < 2) {
      setResults([]);
      setOpen(false);
      return;
    }
    timer.current = setTimeout(async () => {
      try {
        const r = await api.get(`/search?q=${encodeURIComponent(val)}`);
        setResults(r.data?.results || []);
        setOpen(true);
      } catch {
        setResults([]);
      }
    }, 200);
  };

  const go = (to) => {
    setOpen(false);
    if (to) nav(to);
    else nav("/gameday");
  };

  return (
    <div className="relative">
      <div className="rounded-2xl bg-white p-2 card-shadow-lg flex flex-col sm:flex-row gap-2">
        <div className="flex items-center gap-3 flex-1 px-4 py-2">
          <Search className="h-5 w-5 text-muted-foreground shrink-0" />
          <input
            data-testid="home-search-input"
            value={q}
            onChange={onChange}
            onFocus={() => results.length && setOpen(true)}
            onKeyDown={(e) => e.key === "Enter" && go(results[0]?.to)}
            placeholder="Find where to stay for…"
            className="w-full bg-transparent text-sm text-ink placeholder:text-muted-foreground focus:outline-none"
          />
        </div>
        <button
          data-testid="home-search-submit"
          onClick={() => go(results[0]?.to)}
          className="inline-flex items-center justify-center gap-2 rounded-xl bg-primary px-6 py-3 text-sm font-heading font-bold text-primary-foreground transition-transform hover:-translate-y-0.5"
        >
          Explore GameDay <ArrowRight className="h-4 w-4" />
        </button>
      </div>
      {open && results.length > 0 && (
        <div data-testid="home-search-results" className="absolute z-30 mt-2 w-full rounded-xl bg-white card-shadow-lg border border-black/5 overflow-hidden">
          {results.map((r, i) => (
            <button
              key={`${r.to}-${i}`}
              data-testid={`search-result-${i}`}
              onMouseDown={() => go(r.to)}
              className="w-full text-left px-4 py-3 hover:bg-muted/60 flex items-center justify-between gap-4 border-b border-black/5 last:border-0"
            >
              <span className="text-sm font-semibold text-ink truncate">{r.label}</span>
              <span className="text-xs text-muted-foreground shrink-0">{r.sub}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
